import React, { useContext } from 'react';
import { ExamContext } from '../contexts/ExamContext';
import { FaClock } from 'react-icons/fa';

const Timer = () => {
  const { timeLeft } = useContext(ExamContext);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="timer">
      <FaClock style={{ marginRight: '10px', verticalAlign: 'middle' }} />
      Time Remaining: {minutes}:{seconds < 10 ? '0' : ''}{seconds}
    </div>
  );
};

export default Timer;